"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
var agent_message_1 = require("./agent-message");
var channel_messages_1 = require("./channel-messages");
var AWSSSMSession = /** @class */ (function () {
    function AWSSSMSession(streamUrl, sessionId, tokenValue) {
        var _this = this;
        // Each message that is sent to the SSM websocket is assigned a sequenceNumber
        // so the receiver can verify it has not missed any messages (sequenceNumber is
        // an incrementing integer). Also, messages can be ordered back into sequence if
        // anything were to get ahead of line.
        this.outgoingSequenceNumber = 0;
        this.outputMap = new Map();
        this.connectionClosed = false;
        this.connectionTerminated = false;
        this.handlers = [];
        this.paused = false;
        this.streamUrl = streamUrl;
        this.tokenValue = tokenValue;
        this.sessionId = sessionId;
        this.webSocket = new isomorphic_ws_1.default(this.streamUrl);
        this.webSocket.binaryType = 'arraybuffer';
        this.webSocket.onopen = function (ev) {
            _this.webSocket.send(JSON.stringify({
                MessageSchemaVersion: '1.0',
                RequestId: uuid_1.v4(),
                TokenValue: _this.tokenValue,
            }));
            _this.emit('connect', '');
        };
        this.webSocket.onmessage = function (ev) {
            var uint8 = new Uint8Array(ev.data);
            var message = agent_message_1.decode(uint8);
            switch (message.MessageType) {
                case 'output_stream_data': {
                    _this.acknowledgeMessage(message.MessageType, message.MessageId, message.SequenceNumber);
                    var text = message.Payload;
                    if (!_this.outputMap.has(message.MessageId)) {
                        _this.emit('output', text);
                    }
                    _this.outputMap.set(message.MessageId, text);
                    break;
                }
                case 'start_publication': {
                    if (_this.lastAcknowledgedSequenceNumber !== undefined) {
                        _this.outgoingSequenceNumber = _this.lastAcknowledgedSequenceNumber;
                    }
                    else {
                        _this.outgoingSequenceNumber = 0;
                    }
                    _this.paused = false;
                    _this.emit('resume', '');
                    break;
                }
                case 'pause_publication': {
                    _this.paused = true;
                    _this.emit('pause', '');
                    break;
                }
                case 'acknowledge': {
                    if (message.Payload) {
                        var payloadData = JSON.parse(message.Payload);
                        if (_this.lastAcknowledgedSequenceNumber === undefined || _this.lastAcknowledgedSequenceNumber < payloadData.AcknowledgedMessageSequenceNumber) {
                            _this.lastAcknowledgedSequenceNumber = payloadData.AcknowledgedMessageSequenceNumber;
                        }
                    }
                    break;
                }
                case 'input_stream_data': {
                    break;
                }
                case 'channel_closed': {
                    if (message.Payload) {
                        var payloadData = JSON.parse(message.Payload);
                        if (payloadData.Output.length > 0) {
                            _this.emit('output', payloadData.Output + '\r\n');
                        }
                    }
                    _this.connectionTerminated = true;
                    break;
                }
                default: {
                    console.error("Unhandled message type " + message.MessageType + ".");
                }
            }
        };
        this.webSocket.onclose = function (ev) {
            _this.connectionClosed = true;
            _this.emit('disconnect', ev.reason);
        };
    }
    AWSSSMSession.prototype.send = function (message) {
        if (this.webSocket.readyState !== 1) {
            console.warn('WebSocket is not yet ready.');
            return;
        }
        this.outgoingSequenceNumber++;
        this.webSocket.send(message);
    };
    AWSSSMSession.prototype.on = function (eventName, callback) {
        this.handlers.push({
            event: eventName,
            callback: callback,
        });
    };
    AWSSSMSession.prototype.write = function (message) {
        var data = {
            MessageType: channel_messages_1.MessageType.InputStreamDataMessage,
            SequenceNumber: this.outgoingSequenceNumber,
            Payload: message,
            PayloadType: channel_messages_1.PayloadType.Output,
        };
        this.send(agent_message_1.encode(data));
    };
    AWSSSMSession.prototype.ping = function () {
        this.webSocket.send('ping');
    };
    AWSSSMSession.prototype.emit = function (eventName, data) {
        this.handlers.filter(function (h) { return h.event === eventName; }).map(function (h) { return h.callback(data); });
    };
    AWSSSMSession.prototype.setSize = function (cols, rows) {
        var message = {
            MessageType: channel_messages_1.MessageType.InputStreamDataMessage,
            SequenceNumber: this.outgoingSequenceNumber,
            Payload: JSON.stringify({ cols: cols, rows: rows }),
            PayloadType: channel_messages_1.PayloadType.Size,
        };
        this.send(agent_message_1.encode(message));
    };
    AWSSSMSession.prototype.close = function () {
        this.webSocket.close();
    };
    AWSSSMSession.prototype.acknowledgeMessage = function (messageType, messageId, messageSequenceNumber) {
        var message = {
            MessageType: channel_messages_1.MessageType.AcknowledgeMessage,
            SequenceNumber: this.outgoingSequenceNumber,
            PayloadType: channel_messages_1.PayloadType.Output,
            Payload: JSON.stringify({
                AcknowledgedMessageType: messageType,
                AcknowledgedMessageId: messageId,
                AcknowledgedMessageSequenceNumber: messageSequenceNumber,
                IsSequentialMessage: true
            }),
        };
        // Write to the socket without incrementing our own sequence number.
        this.webSocket.send(agent_message_1.encode(message));
    };
    return AWSSSMSession;
}());
exports.default = AWSSSMSession;
